// extracted by mini-css-extract-plugin
export default {"background":"Layout_background__+AMrP","wrap":"Layout_wrap__1iDW1","navbar":"Layout_navbar__12wIw"};